<template>
  <v-autocomplete
    color="primary"
    v-model="foodsSelected"
    :clearable="!unclearable"
    :items="foodsItems"
    :loading="foodsLoading"
    :search-input.sync="foodsSearch"
    item-value="food_relation_id"
    item-text="Description"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('Material.title')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  >
    <template v-slot:item="{ item }">
      {{ item.Description }}
      <span class="caption secondary--text ml-2">
        {{ $t("Material.cookingMethods", [item.behavior_name]) }}
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import FoodRelations from "@/api/food_relations";

export default {
  name: "SearcherFoodRelations",

  props: {
    stockId: Number,
    value: Object,
    noLabel: Boolean,
    label: String,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
  },

  computed: {
    foodsItems() {
      return this.foods.map((food) => {
        const Description = this.dense
          ? food.food_name
          : i18n.t("Material.foodNameWithCode", [
              food.food_code,
              food.food_name,
            ]);
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) =>
                disabledItem.food_relation_id == food.food_relation_id
            )
          : false;
        return Object.assign({}, food, { Description, disabled });
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountSettings"]),
  },

  data: () => ({
    foods: [],
    foodsLoading: false,
    foodsSearch: "",
    foodsSelected: null,
  }),

  methods: {
    getFoodsFromAPI() {
      this.foodsLoading = true;
      // var options = { stock_id: this.stockId };

      FoodRelations.fetch()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.foods = response.data.food_relations;
            }
            this.foodsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.foodsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.foodsSelected = this.value;
        this.getFoodsFromAPI();
      },
    },
    foodsSelected: {
      handler() {
        if (this.foodsSelected && this.foodsSelected.food_relation_id)
          this.$emit("input", this.foodsSelected);
      },
    },
  },
};
</script>
